import { jsxs as S, jsx as s } from "react/jsx-runtime";
import * as i from "react";
import g from "react";
import { u as A } from "./index.CCavb-1K.js";
import { c as B } from "./index.UFb2E87s.js";
import { c as I } from "./index.BMovUuXF.js";
import { u as F } from "./index.um-Vfg-S.js";
import { u as G } from "./index.BZPx6jYI.js";
import { u as H } from "./index.DxV_vweA.js";
import { P as K } from "./index.CSqmdNWN.js";
import { P as w } from "./index.CiR8ycRn.js";
import { c as E } from "./index.rKuIKazb.js";
import { Flex as q } from "../flex.js";
import { Icon as z } from "../icon.js";
import { Label as T } from "../label.js";
import { c as X } from "./create-context.DwEJDSIV.js";
import '../assets/checkbox.css';var N = "Checkbox", [V, _e] = B(N), [$, J] = V(N), D = i.forwardRef(
  (e, d) => {
    const {
      __scopeCheckbox: t,
      name: a,
      checked: p,
      defaultChecked: r,
      required: h,
      disabled: o,
      value: l = "on",
      onCheckedChange: b,
      form: u,
      ..._
    } = e, [n, k] = i.useState(null), C = A(d, (c) => k(c)), x = i.useRef(!1), y = n ? u || !!n.closest("form") : !0, [v = !1, R] = F({
      prop: p,
      defaultProp: r,
      onChange: b
    }), j = i.useRef(v);
    return i.useEffect(() => {
      const c = n == null ? void 0 : n.form;
      if (c) {
        const P = () => R(j.current);
        return c.addEventListener("reset", P), () => c.removeEventListener("reset", P);
      }
    }, [n, R]), /* @__PURE__ */ S($, { scope: t, state: v, disabled: o, children: [
      /* @__PURE__ */ s(
        w.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": m(v) ? "mixed" : v,
          "aria-required": h,
          "data-state": O(v),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: l,
          ..._,
          ref: C,
          onKeyDown: I(e.onKeyDown, (c) => {
            c.key === "Enter" && c.preventDefault();
          }),
          onClick: I(e.onClick, (c) => {
            R((P) => m(P) ? !0 : !P), y && (x.current = c.isPropagationStopped(), x.current || c.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ s(
        Q,
        {
          control: n,
          bubbles: !x.current,
          name: a,
          value: l,
          checked: v,
          required: h,
          disabled: o,
          form: u,
          style: { transform: "translateX(-100%)" },
          defaultChecked: m(r) ? !1 : r
        }
      )
    ] });
  }
);
D.displayName = N;
var L = "CheckboxIndicator", M = i.forwardRef(
  (e, d) => {
    const { __scopeCheckbox: t, forceMount: a, ...p } = e, r = J(L, t);
    return /* @__PURE__ */ s(K, { present: a || m(r.state) || r.state === !0, children: /* @__PURE__ */ s(
      w.span,
      {
        "data-state": O(r.state),
        "data-disabled": r.disabled ? "" : void 0,
        ...p,
        ref: d,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
M.displayName = L;
var Q = (e) => {
  const { control: d, checked: t, bubbles: a = !0, defaultChecked: p, ...r } = e, h = i.useRef(null), o = G(t), l = H(d);
  i.useEffect(() => {
    const u = h.current, _ = window.HTMLInputElement.prototype, k = Object.getOwnPropertyDescriptor(_, "checked").set;
    if (o !== t && k) {
      const C = new Event("click", { bubbles: a });
      u.indeterminate = m(t), k.call(u, m(t) ? !1 : t), u.dispatchEvent(C);
    }
  }, [o, t, a]);
  const b = i.useRef(m(t) ? !1 : t);
  return /* @__PURE__ */ s(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: p ?? b.current,
      ...r,
      tabIndex: -1,
      ref: h,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function m(e) {
  return e === "indeterminate";
}
function O(e) {
  return m(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var U = D, W = M;
const [Pe, Y] = X({
  rootComponentName: "CheckboxGroup"
}), Z = "_checkbox_5frou_3", ee = "_item_5frou_7", te = "_icon_5frou_10", oe = "_disabled_5frou_14", re = "_invalid_5frou_59", ce = "_container_5frou_74", f = {
  checkbox: Z,
  item: ee,
  icon: te,
  disabled: oe,
  invalid: re,
  container: ce
}, ne = g.forwardRef(({ id: e, children: d, value: t, onCheckedChange: a, ...p }, r) => {
  const h = Y(), { disabled: o, invalid: l, onValueChange: b, className: u, ..._ } = {
    ...h,
    ...p
  }, n = l ? { "aria-invalid": !0 } : {}, k = g.useId(), C = e ?? k, x = E(
    f.checkbox,
    {
      [f.invalid]: l,
      [f.disabled]: o
    },
    u
  );
  return /* @__PURE__ */ S(
    q,
    {
      gap: 300,
      className: E(f.container, {
        [f.disabled]: o
      }),
      children: [
        /* @__PURE__ */ s(
          U,
          {
            ..._,
            ...n,
            id: C,
            disabled: o,
            className: x,
            ref: r,
            value: t,
            onCheckedChange: (y) => {
              b && b(t ?? ""), a && a(y);
            },
            children: /* @__PURE__ */ s(
              "div",
              {
                className: E(f.item, {
                  [f.disabled]: o
                }),
                children: /* @__PURE__ */ s(W, { children: /* @__PURE__ */ s(
                  z,
                  {
                    className: f.icon,
                    mode: 200,
                    icon: "successful-checkmark"
                  }
                ) })
              }
            )
          }
        ),
        d && /* @__PURE__ */ s(
          T,
          {
            htmlFor: C,
            className: x,
            color: o ? "c-disabled" : l ? "sig-error" : "c-high-contrast",
            children: d
          }
        )
      ]
    }
  );
});
ne.displayName = "Checkbox";
export {
  ne as C,
  Pe as a
};
//# sourceMappingURL=checkbox.Crz_fNvI.js.map
